import InputCell from "./InputCell";
import { ChildFormProps, References } from "../../../types/Form-types";
import { useState } from "react";

const COLUMNS: {
  label: string;
  field: keyof References;
  type: "text" | "number";
}[] = [
  { label: "Name of Referee", field: "name_of_referee", type: "text" },
  { label: "Designation", field: "designation", type: "text" },
  { label: "Organization", field: "organization", type: "text" },
  { label: "Contact Number", field: "contact_number", type: "number" },
];

const emptyRow = (s_no: number): References => ({
  s_no,
  name_of_referee: "",
  designation: "",
  organization: "",
  contact_number: "",
});

const DEFAULT_REFERENCES: References[] = [
  emptyRow(1),
  emptyRow(2),
  emptyRow(3),
];

interface ReferenceProps extends ChildFormProps {
  handleError: (name: string) => void;
}

const ReferencesDetails = ({
  formData,
  setFormData,
  errors,
  handleError,
}: ReferenceProps) => {
  const [rows, setRows] = useState<References[]>(DEFAULT_REFERENCES);

  const getValue = (e: any): string => {
    if (typeof e === "string") return e;
    return e?.target?.value ?? "";
  };

  const handleRowChange = (
    index: number,
    field: keyof References,
    value: string,
  ) => {
    setRows((prevRows) => {
      const updated = prevRows.map((row, i) =>
        i === index ? { ...row, [field]: value } : row,
      );

      const mapped = updated.filter(
        (row) =>
          row.name_of_referee !== "" ||
          row.designation !== "" ||
          row.organization !== "" ||
          row.contact_number !== "",
      );

      setFormData((prev: any) => ({ ...prev, references: mapped }));
      return updated;
    });
    // ✅ clear specific cell error
    handleError(`references.${index}.${String(field)}`);
  };

  // ✅ add row with next s_no
  const handleAddRow = () => {
    setRows((prev) => [...prev, emptyRow(prev.length + 1)]);
  };

  // ✅ remove row, recalculate s_no
  const handleRemoveRow = (index: number) => {
    setRows((prevRows) => {
      const updated = prevRows
        .filter((_, i) => i !== index)
        .map((row, i) => ({ ...row, s_no: i + 1 })); // ✅ reindex s_no

      const mapped = updated.filter(
        (row) =>
          row.name_of_referee !== "" ||
          row.designation !== "" ||
          row.organization !== "" ||
          row.contact_number !== "",
      );

      setFormData((prev: any) => ({ ...prev, references: mapped }));
      return updated;
    });
  };

  return (
    <div className="pt-3">
      {/* ── Header with Add Row */}
      <div className="mb-3 ">
        <div>
          <p className="form-section-title mb-1">References</p>
          <p
            className="text-muted fst-italic m-0"
            style={{ fontSize: "0.8rem" }}
          >
            (Give references – of superiors you worked with. If you have worked
            with more than one company then ensure that mentioned referees be
            from different companies. Fresher can also give reference of
            professor)
          </p>
        </div>
        <div className="text-end mt-2">
          <button
            type="button"
            onClick={handleAddRow}
            style={{
              background: "none",
              border: "1px dashed #fd7e14",
              color: "#fd7e14",
              borderRadius: "4px",
              padding: "4px 12px",
              fontSize: "0.82rem",
              cursor: "pointer",
            }}
          >
            + Add Row
          </button>
        </div>
      </div>

      <div className="table-responsive mb-4">
        <table className="form-table">
          <thead>
            <tr>
              <th style={{ width: 50 }}>S No.</th>
              <th>Name of Referee</th>
              <th>Designation</th>
              <th>Organization</th>
              <th>Contact Number</th>
              {/* {rows.length > 1 && <th></th>} */}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, i) => (
              <tr key={i}>
                <td>{row.s_no ?? i + 1}</td>
                {COLUMNS?.map((col) => {
                  const errorMsg = errors?.find(
                    (e: any) => String(e?.s_no) === String(row.s_no),
                  )?.[col.field as keyof References];

                  return (
                    <InputCell
                      key={col.field}
                      type={col.type}
                      name={col.field}
                      value={String(row[col.field] ?? "")}
                      handleChange={(e) =>
                        handleRowChange(i, col.field, getValue(e))
                      }
                      errorMessage={errorMsg}
                    />
                  );
                })}

                {/* ✅ remove button — only if more than 1 row
                {rows.length > 1 && (
                  <td style={{ textAlign: "center", width: 40 }}>
                    <button
                      type="button"
                      onClick={() => handleRemoveRow(i)}
                      style={{
                        background: "none",
                        border: "none",
                        color: "#dc3545",
                        cursor: "pointer",
                        fontSize: "1rem",
                        padding: 0,
                      }}
                      title="Remove row"
                    >
                      ✕
                    </button>
                  </td>
                )} */}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ReferencesDetails;

// import InputCell from "./InputCell";
// import { ChildFormProps, References } from "../../../types/Form-types";
// import { useState } from "react";

// // ------ Prev application data --------
// const COLUMNS: {
//   label: string;
//   field: keyof References;
//   type: "text" | "number";
// }[] = [
//   { label: "Name of Referee", field: "name_of_referee", type: "text" },
//   { label: "Designation", field: "designation", type: "text" },
//   { label: "Organization", field: "organization", type: "text" },
//   { label: "Contact Number", field: "contact_number", type: "number" },
// ];

// const DEFAULT_REFERENCES: References[] = [
//   {
//     s_no: 1,
//     name_of_referee: "",
//     designation: "",
//     organization: "",
//     contact_number: "",
//   },
//   {
//     s_no: 2,
//     name_of_referee: "",
//     designation: "",
//     organization: "",
//     contact_number: "",
//   },
//   {
//     s_no: 3,
//     name_of_referee: "",
//     designation: "",
//     organization: "",
//     contact_number: "",
//   },
// ];
// // ------ end employee relation data --------

// interface ReferenceProps extends ChildFormProps {
//   handleError: (name: string) => void;
// }

// const ReferencesDetails = ({
//   formData,
//   setFormData,
//   errors,
//   handleError,
// }: ReferenceProps) => {
//   // const rows: References[] = formData.references ?? [];
//   const [rows, setRows] = useState<References[]>(DEFAULT_REFERENCES);

//   const getValue = (e: any): string => {
//     if (typeof e === "string") return e;
//     return e?.target?.value ?? "";
//   };

//   const handleRowChange = (
//     index: number,
//     field: keyof References,
//     value: string,
//   ) => {
//     setRows((prevRows) => {
//       const updated = prevRows.map((row, i) =>
//         i === index ? { ...row, [field]: value } : row,
//       );

//       // ✅ empty array if no meaningful data (ignore s_no)
//       const mapped = updated.filter(
//         (row) =>
//           row.name_of_referee !== "" ||
//           row.designation !== "" ||
//           row.organization !== "" ||
//           row.contact_number !== "",
//       );

//       setFormData((prev: any) => ({ ...prev, references: mapped }));
//       return updated;
//     });
//     handleError?.("references");
//   };

//   return (
//     <div className="pt-3">
//       <p className="form-section-title mb-1">References</p>
//       <p
//         className="text-muted fst-italic mb-4 2"
//         style={{ fontSize: "0.8rem" }}
//       >
//         (Give references – of superiors you worked with. If you have worked with
//         more than one company then ensure that mentioned referees be from
//         different companies. Fresher can also give reference of professor)
//       </p>
//       <div className="table-responsive mb-4">
//         <table className="form-table">
//           <thead>
//             <tr>
//               <th style={{ width: 50 }}>S No.</th>
//               <th>Name of Referee</th>
//               <th>Designation</th>
//               <th>Organization</th>
//               <th>Contact Number</th>
//             </tr>
//           </thead>
//           <tbody>
//             {rows.map((row, i) => {
//               return (
//                 <tr key={i}>
//                   <td>{row.s_no ?? i + 1}</td>
//                   {COLUMNS?.map((col) => {
//                     const errorMsg = errors?.find(
//                       (e: any) => String(e?.s_no) === String(row.s_no),
//                     )?.[col.field as keyof References];

//                     return (
//                       <InputCell
//                         key={col.field}
//                         type={col.type}
//                         name={col.field}
//                         value={String(row[col.field] ?? "")}
//                         handleChange={(e) =>
//                           handleRowChange(i, col.field, getValue(e))
//                         }
//                         errorMessage={errorMsg}
//                       />
//                     );
//                   })}
//                 </tr>
//               );
//             })}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// };

// export default ReferencesDetails;
